// extracted by mini-css-extract-plugin
export default {"center":"_3xvGS","left":"_3CGAA","right":"_3x5rq"};